var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelledActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancelled-active_svg__a",
    x1: "100%",
    x2: "0%",
    y1: "25.133%",
    y2: "74.867%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F09819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F3D452"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cancelled-active_svg__a)",
    d: "M7.37 17.011L25.791 4l.79 1.333.186 2.966c-1.708.216-2.641 1.052-2.8 2.507-.16 1.454.712 2.436 2.615 2.946l.185 2.95-1.776.977H8.567L7.37 17.01z",
    transform: "translate(1 -1)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#202E4A"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.9,
    d: "M26.557 3.38c.613 0 1.11.497 1.11 1.11v2.8h0c-1.455 0-2.634 1.168-2.634 2.608 0 1.44 1.18 2.608 2.634 2.608v2.8a1.11 1.11 0 01-1.11 1.11H5.073a1.11 1.11 0 01-1.11-1.11v-2.8h0c1.455 0 2.634-1.168 2.634-2.608 0-1.44-1.18-2.607-2.634-2.607V4.49c0-.613.497-1.11 1.11-1.11h21.484z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 1.8,
    d: "M11 7.78h6.095M11 12.18h9.639"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 3.33,
    d: "M1 19.701L30.325-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#202E4A",
    strokeWidth: 1.9,
    d: "M3.037 19.701L28.593 1.383"
  })))));
}
export default SvgCancelledActive;